var useSubtitleElement = function useSubtitleElement(_ref) {
  var title = _ref.title,
    disabled = _ref.disabled;
  var isString = typeof title === 'string';
  var content = isString ? title : title === null || title === void 0 ? void 0 : title.children;
  var variant = !isString && (title === null || title === void 0 ? void 0 : title.variant) || 'body-s';
  var textColor = disabled ? 'base.disabled' : 'base.subtle';
  return {
    content: content,
    variant: variant,
    textColor: textColor
  };
};

export { useSubtitleElement };
//# sourceMappingURL=useSubtitleElement.js.map
